import React from "react";
import { uiUrl } from "../message";
import * as microsoftTeams from '@microsoft/teams-js';

interface IProps {
}

interface IState { }

class Configure extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {};
    }

    handleClick() {
        microsoftTeams.initialize();
        microsoftTeams.settings.setValidityState(true);

        microsoftTeams.settings.registerOnSaveHandler((saveEvent) => {
            microsoftTeams.settings.setSettings({
                websiteUrl: `${uiUrl}`,
                contentUrl: `${uiUrl}`,
                entityId: "Community",
                suggestedDisplayName: "Account Management Tool"
            });
            saveEvent.notifySuccess();
        });
    }

    render() {

        return (
            <div id="content" className="container">
                <button onClick={this.handleClick}>save</button>

            </div>
        );
    }
}

export default Configure;